<template>
  <div>
    <st_header_cop></st_header_cop>
    <div class="index_page contanic_no_lock">
      <!--合作申请-->
      <br><br><br>
      <el-card class="box-card">
        <div class="title_div">项目咨询申请</div>
        <br><br>
        <!--表单内容-->
        <div style="text-align: left">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-input
                placeholder="请输入您的姓名"
                v-model="upData.true_name"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="12">
              <el-input
                placeholder="请输入您所在的城市"
                v-model="upData.city_info"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="24">
              <div class="ver_null"></div>
            </el-col>  <!--竖向间隔-->
            <el-col :span="12">
              <el-input
                placeholder="请输入您的联系电话"
                v-model="upData.mobile_phone"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="12">
              <el-input
                placeholder="请输入您的电子邮箱"
                v-model="upData.email_addr"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="24">
              <div class="ver_null"></div>
            </el-col>  <!--竖向间隔-->
            <el-col :span="24">
              <label class="label_title">请问您是？</label>
              <el-radio v-model="upData.identity" :label="item.content" v-for="item in identi" :key="item.id">{{item.content}}</el-radio>
            </el-col>

            <el-col :span="24">
              <div class="ver_null"></div>
            </el-col>  <!--竖向间隔-->
            <el-col :span="24">
              <label class="label_title">您想要了解？</label>
              <el-radio v-model="upData.want_type" :label="item.content" v-for="item in wanti" :key="item.id">{{item.content}}</el-radio>
            </el-col>

            <el-col :span="24">
              <div class="ver_null"></div>
            </el-col>  <!--竖向间隔-->
            <el-col :span="24">
              <el-input
                type="textarea"
                placeholder="请补充说明您的需求"
                v-model="upData.want_content_info"
                maxlength="500"
                :rows="7"
                show-word-limit
              >
              </el-input>
            </el-col>

            <el-col :span="24">
              <div class="ver_null"></div>
            </el-col>  <!--竖向间隔-->
            <el-col :span="24">
              <div style="width: 100%;text-align: center">
                <el-button type="primary" @click="submitData">提 交</el-button>
              </div>
            </el-col>

          </el-row>
        </div>
      </el-card>
    </div>
    <st_footer_cop
      :active-index="'3'"
      :is_lock_infeed="false">
    </st_footer_cop>
  </div>
</template>

<script>
import st_header from "../components/header_main.vue"
import st_footer from "../components/footer.vue"
import st_list_item_row from '../components/list_item_column'
import { getCooprList,sendCoopr } from '../utils/api'
import { type } from 'os'
export default {
  name:"cooperate",
  components:{
    st_header_cop : st_header,
    st_footer_cop : st_footer,
  },
  data(){
    return {
      identi:[],
      wanti:[],
      upData:{    //上传表单
        true_name:"",
        city_info:"",
        mobile_phone:"",
        email_addr:"",
        identity:"",
        want_type:"",
        want_content_info:""
      }
    }
  },
  methods:{
    submitData(){
      let that = this;
      console.log(this.upData)
      sendCoopr(this.upData)
      .then(function(res){
        if(res.code===1000){
          that.$message({
            message:"您的咨询申请提交成功，之后会有工作人员与您联系",
            type:"success"
          });
          that.upData = {    //上传表单
                          true_name:"",
                          city_info:"",
                          mobile_phone:"",
                          email_addr:"",
                          identity:"",
                          want_type:"",
                          want_content_info:""
                        }
        }else{
          that.$message({
            message:"提交失败，请稍后重试",
            type:"error"
          });
        }
      }).catch(function(err){
        that.$message({
            message:"提交失败，请稍后重试",
            type:"error"
          });
      })
    },
    getIdentifi(){
      let that = this;
      getCooprList({"content_type":"合作身份"})
      .then(function(res){
        if(res.code===1000){
          that.identi = res.data.list //记录当前页数据
        }
      })
    },
    getWant(){
      let that = this;
      getCooprList({"content_type":"合作需求"})
      .then(function(res){
        if(res.code===1000){
          that.wanti = res.data.list //记录当前页数据
        }
      })
    }
  },
  created(){
    this.getIdentifi();
    this.getWant();
  }
}
</script>

<style scoped lang="scss">

.index_page {
  background: rgba(255, 255, 255, 0);
  padding-left: 25%;
  padding-right: 25%;
}


.contanic{
  padding-top: 80px;
  height: 75vh;
}
.contanic_no_lock{
  padding-top: 80px;
  height: auto;
  min-height: 70vh;
}

.title_div {
  font-size: 22px;
  color: #E71489;
  font-weight: 600;
}

.ver_null {
  width: 10px;
  height: 30px
}

.label_title {
  margin-right: 10%;
  color: #666666;
  font-size: 14px
}

</style>



// WEBPACK FOOTER //
// src/view/cooperate.vue